<template>
    <div class="h-100">
        <div class="h-100 d-flex align-content-start">
                <TeamList ref="teamList"></TeamList>
            <div class="col-md-6 h-100 pl-md-4" id="team-info">
                <TeamInfo ref="teamInfo"></TeamInfo>
            </div>
        </div>
        <div class="props-panel">
            <div class="d-flex titlebar" data-toggle="collapse" v-on:click="collapse" href="#props-panel-collapse">
                <div class="ml-2 align-self-center">
                    {{ title }}
                </div>
                <div class="flex-fill"></div>
                <button id="collapse-btn" class="btn btn-outline-secondary btn-collapse align-self-start"
                        data-toggle="collapse" href="#props-panel-collapse" role="button" aria-expanded="false"
                        title="Collapse">
                    <i class="fas fa-chevron-up rotate"></i>
                </button>
            </div>
            <div class="collapse" id="props-panel-collapse">
                <vue-draggable-resizable class="w-100 no-transform" :prevent-deactivation="true" :active="true" :draggable="false"
                                         @resizing="onResize"
                                         :max-height="propsMaxH"
                                         :h="propsH"
                                         :handles="['tm']"
                                         class-name-handle="handle">
                        <div id="props-card" class="card card-body">
                            <TeamPropertiesPane v-show="team !== null"
                                                :on-edit-refresh="onEditTeam"
                                                :on-remove-refresh="onRemoveTeam"
                                                :team="team"
                                                ref="teamProperties">
                            </TeamPropertiesPane>
                            <ProjectPropertiesPane v-show="project !== null"
                                                   :project="project"
                                                   ref="projectProperties">
                            </ProjectPropertiesPane>
                        </div>
                </vue-draggable-resizable>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Component, Ref, Vue} from 'vue-facing-decorator';
  import TeamList from './TeamList.vue';
  import TeamInfo from './TeamInfo.vue';
  import {ProjectDto, TeamDto} from '@/Teams';
  import {LS_KEY_PROPS_PANE_HEIGHT} from '@/utils/LocalStorageKeys';
  import TeamPropertiesPane from './TeamPropertiesPane.vue';
  import ProjectPropertiesPane from './ProjectPropertiesPane.vue';
  import VueDraggableResizable from 'vue-draggable-resizable';

  import $ from 'jquery';

  @Component({
    components: {ProjectPropertiesPane, TeamPropertiesPane, TeamInfo, TeamList, VueDraggableResizable},
  })
  export default class TeamPane extends Vue {
    private propsH = 1;
    private propsMaxH = 1;

    private team: TeamDto | null = null;
    private project: ProjectDto | null = null;

    get title(): string {
      return this.team ? `Team ${this.team.name}` : (this.project ? `Project ${this.project.name}` : "");
    }

    @Ref private teamProperties: TeamPropertiesPane;
    @Ref private projectProperties: ProjectPropertiesPane;
    @Ref public  teamList: TeamList;
    @Ref private teamInfo: TeamInfo;

    public mounted() {
      const panel = $("#props-panel-collapse");
      panel.on("shown.bs.collapse", () => this.resetResizablePanel());
      this.resetResizablePanel();
    }

    public setTeam(team: TeamDto | null) {
      this.teamList.setTeam(team);
      this.teamInfo.setTeam(team);
      this.team = team;
      this.project = null;
    }

    public setProject(project: ProjectDto) {
      this.project = project;
      this.team = null;
    }

    public onRemoveTeam() {
      $('#collapse-btn').trigger('click');
      this.teamList.onRemoveTeamDashboardRefresh();
    }

    public onEditTeam() {
      this.teamList.onEditTeamDashboardRefresh();
    }

    public collapse() {
      $(this.$el).find(".fa-chevron-up").toggleClass('down');
    }

    private setHeight(height: number) {
      this.propsH = height;
      $("#props-panel-collapse").css("height", `${height}px`);
      if (height) {
        $("#props-card").css("height", `${height}px`);
      }
    }

    private resetResizablePanel() {
      this.propsMaxH = Math.max($("main").height() || 1, 1);
      const titlebarHeight = $(this.$el).find(".titlebar").height()
      $(this.$el).find(".handle")
          .css("transform", `translate(0px, -${titlebarHeight}px)`)
      const savedHeight = window.localStorage?.getItem(LS_KEY_PROPS_PANE_HEIGHT);
      this.setHeight(savedHeight !== null ? parseInt(savedHeight, 10) : this.getMaxPropTabHeight());
    }

    private getMaxPropTabHeight(): number {
      const propsCard = $("#props-card");
      const cardVerticalSpacing = propsCard.outerHeight(true) - propsCard.height();
      if (this.teamProperties && this.team) {
        return this.teamProperties.maxTabHeight() + cardVerticalSpacing;
      }
      if (this.projectProperties && this.project) {
        return this.projectProperties.maxTabHeight() + cardVerticalSpacing;
      }
      return 0;
    }

    private onResize(left: number, top: number, width: number, height: number) {
      this.setHeight(height);
      window.localStorage?.setItem(LS_KEY_PROPS_PANE_HEIGHT, `${height}`);
    }
  }
</script>

<style lang="scss">
    @import "sass/components/variables";

    .props-panel {
        z-index: 2;
        position: fixed;
        bottom: 0;
        left:0;
        right: 0;

        .handle {
            background: $gp-orange;
            position: absolute;
            box-sizing: border-box;
            cursor: ns-resize;
            height: 0.5ex;
            width: 100%;
        }
        /**
         * Style for vue-draggable-resizable.
         * We keep sizes of the resizable panel and its parent equal
         * so the panel has to resize without any movements relative to its parent.
         */
        .no-transform {
            transform: translate(0px, 0px) !important;
        }
        .btn-collapse {
            border: none;
            &:focus {
                box-shadow: none;
            }
        }
        .btn-collapse:focus {
        }
        .card {
            background-color: inherit;
            border: none;
        }

        .nav-link {
            color: $gp-dark-brand;
            &.active {
                background-color: $gp-dark-brand;
                color: white;
            }
        }
        #props-card {
          overflow-y: auto;
        }
        #props-panel-collapse {
            background-color: $gp-main-background;
        }
        .rotate{
            -moz-transition: all 0.5s linear;
            -webkit-transition: all 0.5s linear;
            transition: all 0.5s linear;
        }
        .rotate.down{
            -moz-transform:rotate(180deg);
            -webkit-transform:rotate(180deg);
            transform:rotate(180deg);
        }
        .titlebar {
          background-color: $gp-dark-brand;
          color: $gp-light-brand;
          font-weight: bold;
          cursor: pointer;
        }
    }
</style>
